module.exports = __webpack_public_path__ + "static/img/Bachelor_010521.a032f57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010521.jpg
// module id = 177
// module chunks = 0